
export default {
  props: {
    count: {
      // 计数
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    }
  }
}
